const GroupGSTIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="39" height="41" viewBox="0 0 39 41" fill="none">
      <path
        d="M17.96 37.1524L15.4762 39.981L11.8571 37.1524L8.2381 39.981L4.61905 37.1524L1 39.981V1H29.9333V18.7619"
        fill="white"
      />
      <path
        d="M17.96 37.1524L15.4762 39.981L11.8571 37.1524L8.2381 39.981L4.61905 37.1524L1 39.981V1H29.9333V18.7619"
        stroke="#025ECB"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.29529 12.6572H16.5143"
        stroke="#025ECB"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.29529 18.7618H24.3143"
        stroke="#025ECB"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0286 41C34.2572 41 38.4953 36.7619 38.4953 31.5333C38.4953 26.3047 34.2572 22.0667 29.0286 22.0667C23.8 22.0667 19.562 26.3047 19.562 31.5333C19.562 36.7619 23.8 41 29.0286 41Z"
        fill="#3591FE"
      />
      <path
        d="M25.2774 35.5817L33.0165 27.8426"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.4935 30.0171C27.3404 30.0171 28.027 29.3305 28.027 28.4835C28.027 27.6366 27.3404 26.95 26.4935 26.95C25.6465 26.95 24.9599 27.6366 24.9599 28.4835C24.9599 29.3305 25.6465 30.0171 26.4935 30.0171Z"
        fill="white"
      />
      <path
        d="M31.8001 36.4733C32.647 36.4733 33.3336 35.7867 33.3336 34.9398C33.3336 34.0929 32.647 33.4063 31.8001 33.4063C30.9532 33.4063 30.2666 34.0929 30.2666 34.9398C30.2666 35.7867 30.9532 36.4733 31.8001 36.4733Z"
        fill="white"
      />
    </svg>
  );
};
export default GroupGSTIcon;
